
 import Vue from "vue";
    import Component from "vue-class-component";
    import {
        ApplicationsListActions,
        ApplicationsListClient, factory, HeaderNotificationClient, HeaderNotificationModel, NotificationsActions, NotificationsClient,
        UserActions, UsersClient
    } from "@/api-client";
    import {authService} from "@/AuthService";
    import {Culture, cultureService} from "@/CultureService";
    import userInfo from "@/features/shared/components/UserInfo";
    import NavNotification from "@/features/notifications/components/NavNotifications.vue";
 import {logoService} from "@/LogoService";
 import globalLoader from "@/globalLoader";
 import bus from "@/EventBus";

class HeaderNotificationLocalized{
    title = "";
    message = "";
    isActive = false;
}

    @Component({
        components: {
            NavNotification
        }
    })
    export default class NavMain extends Vue {
        mainNavActions: UserActions = factory.create(UserActions);
        applicationsListActions: ApplicationsListActions = factory.create(ApplicationsListActions);
        notificationsActions: NotificationsActions = factory.create(NotificationsActions);
        isNavCollapsedOpen = false;
        headerNotification: HeaderNotificationModel = factory.create(HeaderNotificationModel);

        get canChooseProfile(){
            const hasOnlySeafarerOrAccessLinkProfile = this.authService.availableProfiles.length == 1 && (this.authService.availableProfiles[0].isSeafarer || this.authService.availableProfiles[0].isAccessLinkUser);
            return !hasOnlySeafarerOrAccessLinkProfile;
        }
        
        async changeLanguage() {
            switch(cultureService.currentCulture){
                case Culture.Estonian:
                    await cultureService.changeToEnglish();
                    return;
                case Culture.English:
                    await cultureService.changeToEstonian();
                    return;
            }
        }

        get changeLanguageText() : string{
            switch(cultureService.currentCulture){
                case Culture.Estonian:
                    return this.$ls.Global_Nav_Item_ChangeLanguageToEnglish;
                case Culture.English:
                    return this.$ls.Global_Nav_Item_ChangeLanguageToEstonian;
            }
            throw Error("unknown language.")
        }
        
        get userDisplayName(): string {
            return this.userInfo.isAccessLinkUser // Handle access link user "name" differently to change it when changing system language.
                ? this.$ls.Global_MisUserRole_AccessLinkUser
                : this.userInfo.fullName || this.userInfo.userName
        }
        
        userInfo = userInfo;
        authService = authService;

        hasProfileSelected(){
            return this.authService.hasProfileSelected();
        }

        async created() {
            bus.subscribe("header-notification-updated", () => {
                console.log("header-notification-updated")
                new HeaderNotificationClient().get().then(a => this.headerNotification = a)
            }, this);
            this.$watch(
                () => this.userInfo,
                async () => await this.updateAvailableActions(),
                { deep: true, immediate: true });
        }

        async updateAvailableActions() {
            await Promise.all([
                new ApplicationsListClient().availableActions().then(a => this.applicationsListActions = a),
                new UsersClient().availableActions().then(a => this.mainNavActions = a),
                new NotificationsClient().availableActions().then(a => this.notificationsActions = a),
                new HeaderNotificationClient().get().then(a => this.headerNotification = a),
            ])
        }

        async logout() {
            globalLoader.startLoading(); // Unload components and show loader ASAP.
            await this.authService.logout();
        }
        
        getVariant(): string {
            return this.authService.isLoggedIn ? "primary" : "white";
        }

        getType(): string {
            return this.authService.isLoggedIn ? "dark" : "light";
        }

        getNotificationType(): string {
            return this.authService.isLoggedIn ? "light": "dark";
        }

        getLogo() {
            const useColor = !authService.isLoggedIn;
            return logoService.getLogoName(useColor)
        }

        getLogoMobile() {
            const useColor = !authService.isLoggedIn;
            return logoService.getMobileLogoName(useColor);
        }

        get headerNotificationLocalized(): HeaderNotificationLocalized {
            switch(cultureService.currentCulture){
                case Culture.Estonian:
                    return {
                        title: this.headerNotification.title,
                        message: this.headerNotification.message,
                        isActive: this.headerNotification.isActive && (this.headerNotification.title.length > 0 || this.headerNotification.message.length > 0)
                    }
                case Culture.English:
                    return {
                        title: this.headerNotification.titleEn,
                        message: this.headerNotification.messageEn,
                        isActive: this.headerNotification.isActive && (this.headerNotification.titleEn.length > 0 || this.headerNotification.messageEn.length > 0)
                    }
            }
            throw Error("unknown language.")
        }

        get isLoggedIn(): boolean {
            return this.authService.isLoggedIn;
        }

        closeCollapseNav() {
            this.isNavCollapsedOpen = false;
        }

        async logIn(){
            const returnUrl = window.location.pathname + window.location.search;
            await this.authService.startAuthentication(encodeURI(returnUrl));
        }
    }
